import { Route, redirect } from "@tanstack/react-router";
import { rootRoute } from "../root";

export const interventionsAnimalWelfareRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "/interventions/animal-welfare",
  beforeLoad: () => {
    throw redirect({ to: "/" });
  },
});
